import AccordionBody from "Components/Common/components/Accordion/AccordionBody"
import AccordionHeader from "Components/Common/components/Accordion/AccordionHeader"
import AccordionLayout from "Components/Common/components/Accordion/AccordionLayout"
import React, { useContext, useEffect, useRef, useState } from "react"
import { TAttribute } from "types/Pages/ProductDelta"
import AttributeValueList from "./AttributeValueList"
import CustomSearchBar from "../components/CustomSearchBar"
import { TFilters } from "types/hooks/useTable"
import { debounce } from "lodash"
import { ProductsContext } from "../ProductsContext"

type MyProps = {
    attributes: TAttribute[] | null
    handleChange: (ids: string[]) => void,
    filters: TFilters
}

/**
 * List of attributes and attribute values
 * as pills
 * 
 * @param param0 
 * @returns 
 */
const AttributeListPill = ({ attributes, filters, handleChange }: MyProps) => {
    const [selected, setSeleted] = useState<string[]>(filters.filters ?? [])
    const selectedRef = useRef<string[]>(filters.filters ?? []);
    const prodContext = useContext<any>(ProductsContext)
    const [accordionPages, setAccordionPages] = useState(new Map());

    const getPage = (attributeId: string) => {
        return accordionPages.get(attributeId) || 1;
    };

    const setPage = (attributeId: string, newPage: number) => {
        setAccordionPages((prev) => {
            const updatedMap = new Map(prev);
            updatedMap.set(attributeId, newPage);
            return updatedMap;
        });
    };

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>, attributeValueId: string, attributeId: string, attributeName: string, attributeValueName: string) => {
        e.preventDefault()

        prodContext.selectedFilterList.current = prodContext.toggleAttributeValueInPlace(prodContext.selectedFilterList.current, attributeId, attributeName, attributeValueId, attributeValueName);

        const index = selected.indexOf(attributeValueId)
        if (index === -1) setSeleted(prev => {
            selectedRef.current = [...prev, attributeValueId]
            return [...prev, attributeValueId]
        })
        else setSeleted(prev => {
            const nextAttrs = [...prev]
            nextAttrs.splice(index, 1)
            selectedRef.current = nextAttrs
            return nextAttrs
        })
    }

    const onHeaderExpanded = async (attributeId: string) => {
        const attrValues = prodContext.attributes?.filter((e: TAttribute) => e.id === attributeId)[0]?.values ?? [];
        if (attrValues?.length === 0) {
            await getAttributeValues(attributeId);
        }
    }

    const getAttributeValues = async (attributeId: string, page: number | null = 1, query: string | null = '') => {
        return await prodContext.fetchAttributeValues(attributeId, page, query, selectedRef.current);
    }

    useEffect(() => {
        handleChange(selected)
    }, [selected])

    const debouncedSearch = debounce((value) => {
        prodContext.handleCategorySearchChange(value)
    }, 500);

    return (
        <div>
            <div className={`tw-py-2`}>
                <CustomSearchBar
                    delay={200}
                    handleSearchChange={(query) => debouncedSearch(query)}
                    placeholder="Search Attributes"
                    autoComplete="off"
                />
            </div>
            {
                prodContext.loadingAttributes && attributes?.length === 0 ? <div>loading...</div> : !attributes || attributes?.length === 0 ? <div>No attribute found</div> :
                    attributes
                        ?.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }))
                        .map((attribute) => (
                            <div key={attribute.id}>
                                <AccordionLayout>
                                    {(provided) => (
                                        <>
                                            <AccordionHeader {...provided.getHeaderProps()} onClickedHeader={() => onHeaderExpanded(attribute.id)}>
                                                <div className={`tw-font-semibold`}>
                                                    {attribute.name}
                                                </div>
                                            </AccordionHeader>

                                            <AccordionBody {...provided.getBodyProps()}>
                                                <AttributeValueList
                                                    attribute_values={attribute.values}
                                                    handleClick={(e, id, attributeValueName) => handleClick(e, id, attribute.id, attribute.name, attributeValueName)}
                                                    selected={selected}
                                                    loadAttributeValues={(query: string, page: number) => getAttributeValues(attribute.id, page, query)}
                                                    attributeValueCount={attribute.attributeValueCount}
                                                    page={getPage(attribute.id)}
                                                    setPage={(newPage: number) => setPage(attribute.id, newPage)}
                                                />
                                            </AccordionBody>
                                        </>
                                    )}
                                </AccordionLayout>
                            </div>
                        ))
            }
        </div>
    )
}

export default AttributeListPill